<template>
  <div class="like-container">
    <h5 class="like-prompt">{{ $t("descriptions.like") }}</h5>
    <div class="like">
      <div v-if="article.isAllowReact" class="rainbow-heart" id="like-btn" :data-article-id="article.id">
        <div class= "bubble"></div>
        <i class="fas fa-heart like-icon active" aria-hidden="true" />
      </div>
      <div v-else class="rainbow-heart" id="like-btn" :data-article-id="article.id">
        <div class= "bubble"></div>
        <i class="fas fa-heart like-icon" aria-hidden="true" />
      </div>
      <p class="quantity-like">{{ likesCountText }}</p>
    </div>
  </div>
</template>

 <script>
  export default {
    name: "ReactionButton",
    props: {
      article: {
        default: () => {},
        type: Object,
      },
    },
    computed: {
      likesCountText() {
        return this.article.likesCount ? this.article.likesCount : "-";
      }
    }
  }
 </script>